import React, { useMemo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import { useForm, useFieldArray } from "react-hook-form";
import { LoadingOutlined } from "@ant-design/icons";
import { useMutation } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";

import { getBulkUserUploadSchema } from "../../../schema/user.schema";
import { setBulkUser, setUserInvitation } from "../../../api/user";
import BulkUserCreationTable from "./BulkUserCreationTable";

const BulkUserFormElement = (props) => {
  const { hotelList, mappedRoles, mainRoles, userData, applications, applicationRoles } = props;

  const [btnDisable, setBtnDisable] = useState(false);
  const [start, setStart] = useState(false);
  const [statusArray, setStatusArray] = useState([]);


  const { mutateAsync: userUpdate } = useMutation(setBulkUser);
  const { mutateAsync: sendUserInvitation } = useMutation(setUserInvitation);

  const schema = getBulkUserUploadSchema(hotelList, mainRoles, mappedRoles);

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      formData: userData,
    },
    resolver: yupResolver(schema),
  });
  const { fields, remove, replace } = useFieldArray({
    control,
    name: "formData",
  });

  const onSubmit = async (data) => {
    const { formData } = data;
    const appIdList = applications.map(app=>app._id);

    const submitData = formData.map(userRecord => {
      const record = {
        ...userRecord,
      }
      const app_roles = []
      appIdList.forEach(appId=>{
        if(record[appId]){
          app_roles.push(record[appId]);
        }
        delete record[appId];
      })
      record.app_roles = app_roles;
      return record;
    });
    setStart(true);

    const statusArr = [];
    for (let index = 0; index < submitData.length; index++) {
      statusArr.push(<LoadingOutlined />);
    }
    setStatusArray(statusArr);

    let k=0;
    for (const userRecord of submitData) {
      let statusMessage = "User Creation Failed";
      try {
        const userUpdateResponse = await userUpdate({ data: userRecord });
        if (userRecord.account_activation === true) {
          statusMessage = "Account Activation Failed";
          const userInvitationResponse = await sendUserInvitation({data:{
            user_id: userUpdateResponse?.data?._id,
            email: userRecord.email,
            bulk_user_creation: true,
          }})
          if(!userInvitationResponse.error){
            statusMessage = userInvitationResponse.message;
          }
        } else {
          statusMessage = userUpdateResponse.message;
        }
      } catch (error) {
        // statusMessage = error?.response?.data?.message;
      }

      setStatusArray(prevState => {
        const updatedValues=[...prevState];
        updatedValues[k] = statusMessage;
        return updatedValues;
      });
      k++
    }
    setBtnDisable(false);
  };

  useEffect(() => {
    reset({
      data: "formData",
    });
    setStatusArray([]);
    replace(userData);
  }, [userData]);

  //  useEffect(() => {
  //   const subscription = watch((data) => {
  //     console.log(data, "form data");
  //   });
  //   return () => subscription.unsubscribe();
  // }, [watch]);


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <BulkUserCreationTable
        dataSource={fields}
        errors={errors}
        control={control}
        hotelList={hotelList}
        mainRoles={mainRoles}
        mappedRoles={mappedRoles}
        watch={watch}
        statusArray={statusArray}
        remove={remove}
        start={start}
        applications={applications}
        applicationRoles={applicationRoles}
      />
      <div style={{ textAlign: "center", paddingTop: "20px" }}>
        <Button
          type="primary"
          disabled={btnDisable || fields.length === 0}
          htmlType="submit"
        >
          Process
        </Button>
      </div>
    </form>
  );
};

BulkUserFormElement.propTypes = {};

export default BulkUserFormElement;
